/* eslint-disable react/require-default-props */
import { Slider } from "@material-ui/core";
import clsx from "clsx";
import {
	CustomSlider,
	CustomValueLabel,
} from "components/RevampFeedDetails/JobFeed/components/DesktopFilters";
import React from "react";
import { getGlobalCSSVariants } from "theme";
import { isHostLaunchedMicrosite } from "utils";
import { MICROSITES } from "utils/constants";

type Marks = {
	value: number;
	label: string;
};

type InputSliderProps = {
	isDesktopView?: boolean;
	showValueLabel?: boolean;
	heading: string;
	value: number | number[];
	minValue: number;
	maxValue: number;
	step?: number;
	onChange: (e: React.ChangeEvent<{}>, v: number | number[]) => void;
	handleScale?: (x: any) => any;
	handleValueLabelFormat?: (x: any) => any;
	marks?: Marks[];
	startMark?: string;
	endMark?: string;
};

const InputSlider: React.FC<InputSliderProps> = ({
	isDesktopView = true,
	showValueLabel = false,
	heading,
	value,
	minValue,
	maxValue,
	marks = [],
	step = 1,
	onChange,
	handleScale = (x) => x,
	handleValueLabelFormat = (x) => x,
	startMark = "",
	endMark = "",
}) => (
	<div>
		<div
			className={clsx("relative z-10 mb-[16px] mt-[24px] text-[#8C8594]", {
				"text-[14px] leading-[20px]": isDesktopView,
				"text-[12px] leading-[16px]": !isDesktopView,
			})}
		>
			{heading}
		</div>
		<div className="w-[95%]">
			<div className="relative w-[100%]">
				<CustomSlider
					step={step}
					value={value}
					marks={marks}
					min={minValue}
					max={maxValue}
					valueLabelDisplay="on"
					onChange={(event, val) => {
						onChange(event, val);
					}}
					ValueLabelComponent={CustomValueLabel}
					scale={handleScale}
					valueLabelFormat={handleValueLabelFormat}
				/>
				{startMark && (
					<div className="absolute bottom-[-15px] left-0 text-[14px] leading-[20px] text-[#827485]">
						{startMark}
					</div>
				)}
				{endMark && (
					<div className="absolute bottom-[-15px] right-[-5px] text-[14px] leading-[20px] text-[#827485]">
						{endMark}
					</div>
				)}
			</div>
		</div>
	</div>
);

export default InputSlider;
